export default "__VITE_ASSET__c5c3e7f6__"